import Link from "./Link";
import VideoLink from "./VideoLink";
import "./Link.css";
import React from "react";
import ReactDOM from "react-dom";

class Links extends React.Component {
    // constructor(props) {
    //     super(props);
    //     this.state = { showLinks: false }; 
    //     this.toggleLinks = this.toggleLinks.bind(this);
    // }
     
      
    // toggleLinks(){
    //     event.preventDefault();
    //     let showLinksNew = !this.state.showLinks ;
    //     this.setState({ showLinks : showLinksNew });
    // } 
    render(){
        switch (this.props.layout) {
            // case 'third':
            //     return (
            //         <div className="audioLinks col-12">
            //             {this.props.items.map((item,index) => (
            //                 <AudioLink data={item}  key={"link_"+index}/>
            //             )) }
            //         </div>
            //         ); 
            //     break;
            case 'third':
                return (
                    <div className="audioLinks col-12">
                        {this.props.items.map((item,index) => (
                            <VideoLink data={item}  key={"link_"+index}/>
                        )) }
                    </div>
                    ); 
                break;
                                        
            default:
                return (
                    <div className="titleLinks">
                        <h2 className="col-12">{this.props.modText}</h2>
                        {this.props.layout == 'first' ? <h3 className="col-12 allInfo">כל המידע והפעולות לנוחיותכם</h3> :
                        <div className="memorialDay">
                            <h3 className="col-12">יום הזיכרון לחללי מערכות ישראל</h3>
                            <div className="MemorialDayLinks col-12">
                                {this.props.items.map((item,index) => (
                                    <Link data={item}  key={"link_"+index}/>
                                )) }
                            </div>
                            <h3 className="col-12 allInfo">כל המידע והפעולות לנוחיותכם</h3>
                        </div>}
                    </div>
                    ); 
                break;
        }
        
        }
}
export default Links;

{/* <div className="linksWrap">
                    
                    <button  className="toggleLinks readMoreDiv " onClick={this.toggleLinks} aria-expanded={this.state.showLinks? 'true': 'false'}>אוכלוסיית היעד<i className={"fas fa-angle-double-"+(this.state.showLinks? 'right': 'left')}/></button>
                    <div className={"linksDrawer " + (this.state.showLinks? 'open': '')}  aria-hidden={this.state.showLinks? 'false': 'true'} >
                        {this.props.items.map((item,index) => (
                            <Link data={item} key={"link_"+index}/>
                        )) }
                    </div>
                </div> */}